export enum STORAGE_KEY {
  PAGINATION = 'pagination',
  FILTERS = 'filters',
  VISIBLE_COLUMNS = 'visible_columns',
  SORT_BY = 'sort_by',
}
